import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Home() {
  const navigate = useNavigate();
  const [hoveredService, setHoveredService] = useState(null);
  const [user, setUser] = useState(null);

  // 사용자 정보 로드
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  // 네비게이션 함수
  const handleNavigate = (path) => {
    if (!user && (path === '/match' || path === '/guild' || path === '/community')) {
      alert('로그인이 필요한 서비스입니다.');
      navigate('/login');
      return;
    }
    navigate(path);
  };



  // 주요 서비스 바로가기 메뉴 (2x3 그리드로 대칭 구성)
  const quickServices = [
    {
      icon: '⚔️',
      title: '매칭 신청',
      description: '실시간 경기 매칭',
      path: '/match',
      color: '#ff6b6b',
      requireLogin: true
    },
    {
      icon: '🏰',
      title: '길드 찾기',
      description: '내 취향의 길드 가입',
      path: '/guild',
      color: '#4ecdc4',
      requireLogin: true
    },
    {
      icon: '🏆',
      title: '대회 참가',
      description: '공식 토너먼트 참여',
      path: '/tournaments',
      color: '#45b7d1',
      requireLogin: false
    },
    {
      icon: '🏅',
      title: '랭킹 보기',
      description: '개인/길드 순위 확인',
      path: '/ranking',
      color: '#96ceb4',
      requireLogin: false
    },
    {
      icon: '💬',
      title: '커뮤니티',
      description: '자유 소통 공간',
      path: '/community',
      color: '#f093fb',
      requireLogin: true
    },
    {
      icon: '📊',
      title: '내 프로필',
      description: '전적 및 통계 확인',
      path: user ? `/mypage/${user.id}` : '/login',
      color: '#feca57',
      requireLogin: true
    }
  ];



  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: 0,
      margin: 0,
    }}>
      {/* 플로팅 애니메이션 CSS */}
              <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        
        @media (max-width: 768px) {
          .hero-title {
            fontSize: 36px !important;
          }
          .hero-subtitle {
            fontSize: 16px !important;
          }
          .section-title {
            fontSize: 24px !important;
          }
          .quick-services-grid {
            gridTemplateColumns: repeat(2, 1fr) !important;
            gap: 16px !important;
          }
          .quick-service-item {
            padding: 20px 12px !important;
          }
          .quick-service-icon {
            fontSize: 28px !important;
          }
          .quick-service-title {
            fontSize: 14px !important;
          }
          .quick-service-desc {
            fontSize: 11px !important;
          }
        }
        
        @media (max-width: 480px) {
          .hero-title {
            fontSize: 28px !important;
          }
          .cta-buttons {
            flexDirection: column !important;
            alignItems: center !important;
          }
          .cta-buttons button {
            width: 100% !important;
            maxWidth: 280px !important;
          }
        }
      `}</style>

      {/* 히어로 섹션 */}
      <div style={{
        textAlign: 'center',
        padding: '80px 20px 60px',
        position: 'relative'
      }}>
        {/* 배경 장식 */}
        <div style={{
          position: 'absolute',
          top: '20%',
          left: '10%',
          width: 100,
          height: 100,
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.1)',
          animation: 'float 6s ease-in-out infinite'
        }} />
        <div style={{
          position: 'absolute',
          top: '60%',
          right: '15%',
          width: 60,
          height: 60,
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.1)',
          animation: 'float 4s ease-in-out infinite reverse'
        }} />

        <div style={{
          fontSize: 18,
          fontWeight: 600,
          color: 'rgba(255,255,255,0.9)',
          marginBottom: 16,
          letterSpacing: '1px'
        }}>
          🚀 랭킹·매칭·기록, 한 번에!
        </div>

        <h1 className="hero-title" style={{
          fontSize: 48,
          fontWeight: 900,
          color: '#fff',
          margin: '0 0 24px 0',
          textShadow: '0 4px 20px rgba(0,0,0,0.3)',
          lineHeight: 1.2
        }}>
          <span style={{ color: '#FFD700' }}>Sportier</span>
        </h1>

        <p className="hero-subtitle" style={{
          fontSize: 20,
          color: 'rgba(255,255,255,0.9)',
          maxWidth: 600,
          margin: '0 auto 40px',
          lineHeight: 1.6
        }}>
          🏓 탁구부터 🎳 볼링까지, 다양한 스포츠를 통해 새로운 도전과 만남을 시작하세요
        </p>

        {/* 주요 서비스 바로가기 - 대칭적 2x3 그리드 */}
        <div style={{
          background: 'rgba(255,255,255,0.1)',
          backdropFilter: 'blur(15px)',
          borderRadius: 24,
          padding: '40px 20px',
          margin: '0 auto 40px',
          maxWidth: 1000,
          border: '1px solid rgba(255,255,255,0.2)'
        }}>
          <h2 className="section-title" style={{
            fontSize: 28,
            fontWeight: 800,
            color: '#fff',
            margin: '0 0 32px 0',
            textShadow: '0 2px 10px rgba(0,0,0,0.3)'
          }}>
            ⚡ 빠른 서비스 이용
          </h2>

          <div className="quick-services-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gridTemplateRows: 'repeat(2, 1fr)',
            gap: 20,
            maxWidth: 900,
            margin: '0 auto'
          }}>
            {quickServices.map((service, index) => (
              <button
                key={service.title}
                className="quick-service-item"
                onClick={() => handleNavigate(service.path)}
                onMouseEnter={() => setHoveredService(index)}
                onMouseLeave={() => setHoveredService(null)}
                style={{
                  background: hoveredService === index 
                    ? `linear-gradient(135deg, ${service.color} 0%, ${service.color}90 100%)`
                    : 'rgba(255,255,255,0.1)',
                  border: `2px solid ${hoveredService === index ? service.color : 'rgba(255,255,255,0.2)'}`,
                  borderRadius: 20,
                  padding: '28px 20px',
                  cursor: 'pointer',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  transform: hoveredService === index ? 'translateY(-8px) scale(1.02)' : 'translateY(0) scale(1)',
                  boxShadow: hoveredService === index 
                    ? `0 20px 40px ${service.color}30, 0 8px 16px ${service.color}20`
                    : '0 8px 25px rgba(0,0,0,0.1)',
                  backdropFilter: 'blur(10px)',
                  color: '#fff',
                  fontSize: 14,
                  fontWeight: 600,
                  minHeight: 140,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 8
                }}
              >
                <div className="quick-service-icon" style={{
                  fontSize: 36,
                  marginBottom: 8,
                  transform: hoveredService === index ? 'scale(1.1) rotate(5deg)' : 'scale(1) rotate(0deg)',
                  transition: 'transform 0.3s ease',
                  filter: hoveredService === index ? 'drop-shadow(0 4px 8px rgba(0,0,0,0.2))' : 'none'
                }}>
                  {service.icon}
                </div>
                <div className="quick-service-title" style={{
                  fontSize: 16,
                  fontWeight: 700,
                  marginBottom: 4,
                  color: '#fff',
                  textAlign: 'center'
                }}>
                  {service.title}
                </div>
                <div className="quick-service-desc" style={{
                  fontSize: 12,
                  color: 'rgba(255,255,255,0.9)',
                  lineHeight: 1.3,
                  textAlign: 'center',
                  opacity: 0.9
                }}>
                  {service.description}
                </div>
                {service.requireLogin && !user && (
                  <div style={{
                    fontSize: 10,
                    color: '#FFD700',
                    marginTop: 4,
                    fontWeight: 600,
                    background: 'rgba(255, 215, 0, 0.2)',
                    padding: '2px 8px',
                    borderRadius: 12,
                    border: '1px solid rgba(255, 215, 0, 0.3)'
                  }}>
                    로그인 필요
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>

        {user && (
          <button
            onClick={() => navigate(`/mypage/${user.id}`)}
            style={{
              background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
              border: 'none',
              borderRadius: 16,
              padding: '16px 32px',
              color: '#333',
              fontSize: 16,
              fontWeight: 700,
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 8px 25px rgba(255,215,0,0.4)',
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px) scale(1.05)';
              e.currentTarget.style.boxShadow = '0 12px 35px rgba(255,215,0,0.6)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0) scale(1)';
              e.currentTarget.style.boxShadow = '0 8px 25px rgba(255,215,0,0.4)';
            }}
          >
            🏠 내 프로필 보기
          </button>
        )}
      </div>







      {/* CTA 섹션 + 회원가입 버튼 */}
      <div style={{
        textAlign: 'center',
        padding: '80px 20px',
        background: 'rgba(0,0,0,0.1)'
      }}>
        <h2 className="section-title" style={{
          fontSize: 28,
          fontWeight: 700,
          color: '#fff',
          margin: '0 0 16px 0'
        }}>
          🚀 지금 바로 시작하세요!
        </h2>
        <p style={{
          fontSize: 16,
          color: 'rgba(255,255,255,0.8)',
          maxWidth: 500,
          margin: '0 auto 32px',
          lineHeight: 1.6
        }}>
          스포츠를 통한 새로운 만남과 도전이 기다리고 있습니다. 
          지금 가입하고 첫 경기를 시작해보세요!
        </p>

        <div className="cta-buttons" style={{
          display: 'flex',
          gap: 16,
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          {!user ? (
            <>
              <button
                onClick={() => navigate('/login')}
                style={{
                  background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
                  border: 'none',
                  borderRadius: 16,
                  padding: '16px 32px',
                  color: '#333',
                  fontSize: 16,
                  fontWeight: 700,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 8px 25px rgba(255,215,0,0.4)',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 8
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-3px) scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 12px 35px rgba(255,215,0,0.6)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(255,215,0,0.4)';
                }}
              >
                🚀 회원가입하고 시작하기
              </button>

              <button
                onClick={() => navigate('/intro')}
                style={{
                  background: 'transparent',
                  border: '2px solid rgba(255,255,255,0.3)',
                  borderRadius: 16,
                  padding: '16px 32px',
                  color: '#fff',
                  fontSize: 16,
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  backdropFilter: 'blur(10px)'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.1)';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                📖 서비스 소개 보기
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate('/match')}
                style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  border: 'none',
                  borderRadius: 16,
                  padding: '16px 32px',
                  color: '#fff',
                  fontSize: 16,
                  fontWeight: 700,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 8px 25px rgba(102,126,234,0.4)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 8
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-3px) scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 12px 35px rgba(102,126,234,0.6)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(102,126,234,0.4)';
                }}
              >
                ⚔️ 첫 경기 시작하기
              </button>

              <button
                onClick={() => {
                  const myGuildId = localStorage.getItem('myGuildId');
                  if (myGuildId) {
                    navigate(`/guild/${myGuildId}`);
                  } else {
                    navigate('/guild');
                  }
                }}
                style={{
                  background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                  border: 'none',
                  borderRadius: 16,
                  padding: '16px 32px',
                  color: '#fff',
                  fontSize: 16,
                  fontWeight: 700,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 8px 25px rgba(240,147,251,0.4)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 8
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-3px) scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 12px 35px rgba(240,147,251,0.6)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(240,147,251,0.4)';
                }}
              >
                🏰 길드 가입하기
              </button>
            </>
          )}
        </div>

        {/* 추가 정보 */}
        <div style={{
          marginTop: 48,
          padding: '32px',
          background: 'rgba(255,255,255,0.05)',
          borderRadius: 20,
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255,255,255,0.1)',
          maxWidth: 600,
          margin: '48px auto 0'
        }}>
          <h3 style={{
            fontSize: 20,
            fontWeight: 700,
            color: '#FFD700',
            margin: '0 0 16px 0'
          }}>
            ✨ Sportier만의 특별한 점
          </h3>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
            gap: 16,
            textAlign: 'left'
          }}>
            <div>
              <div style={{ fontSize: 18, marginBottom: 4 }}>🎯</div>
              <div style={{ fontSize: 14, color: '#fff', fontWeight: 600 }}>정확한 매칭</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>실력별 공정한 경기</div>
            </div>
            <div>
              <div style={{ fontSize: 18, marginBottom: 4 }}>📱</div>
              <div style={{ fontSize: 14, color: '#fff', fontWeight: 600 }}>모바일 최적화</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>언제 어디서나 접속</div>
            </div>
            <div>
              <div style={{ fontSize: 18, marginBottom: 4 }}>🏆</div>
              <div style={{ fontSize: 14, color: '#fff', fontWeight: 600 }}>성장 시스템</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>티어업의 재미</div>
            </div>
            <div>
              <div style={{ fontSize: 18, marginBottom: 4 }}>👥</div>
              <div style={{ fontSize: 14, color: '#fff', fontWeight: 600 }}>활발한 커뮤니티</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>함께 성장하는 즐거움</div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)', zIndex: 9999 }}>
        <button onClick={() => window.location.href = '/'} style={{ padding: '16px 40px', borderRadius: 24, background: '#10b981', color: '#fff', fontWeight: 800, fontSize: 20, border: 'none', cursor: 'pointer', boxShadow: '0 4px 16px #10b98133', letterSpacing: 1 }}>
          홈 화면으로 이동
        </button>
      </div>
    </div>
  );
}

export default Home;